<template>
    <div>
      <trademark-opposition-status-list></trademark-opposition-status-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  